import React, { useEffect, useRef, useState } from "react";
import { checklist, upload_files } from "../api";
import { useNavigate } from "react-router-dom";
import LoadingScreen from "react-loading-screen";
import { toast } from "react-toastify";

/* ------------------------------------------------------------------ */
/*  Icons — same lightweight inline SVG set used in Dynamicgraph       */
/* ------------------------------------------------------------------ */
const Icon = ({ children, size = 16, className = "", ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...rest}
  >
    {children}
  </svg>
);

const makeIcon = (children) => (props) => <Icon {...props}>{children}</Icon>;

const IconUploadCloud = makeIcon(
  <>
    <path d="M4 14.9A7 7 0 1 1 15.7 8h1.8a4.5 4.5 0 0 1 2.5 8.2" />
    <path d="M12 12v9" />
    <path d="m16 16-4-4-4 4" />
  </>
);
const IconFileText = makeIcon(
  <>
    <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
  </>
);
const IconClose = makeIcon(
  <>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </>
);
const IconInfo = makeIcon(
  <>
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="16" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12.01" y2="8" />
  </>
);
const IconChevronDown = makeIcon(<polyline points="6 9 12 15 18 9" />);
const IconCheckCircle = makeIcon(
  <>
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </>
);
const IconInbox = makeIcon(
  <>
    <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
    <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
  </>
);

/* ------------------------------------------------------------------ */
/*  Small shared pieces                                                 */
/* ------------------------------------------------------------------ */
const SectionTitle = ({ title, pill }) => (
  <div className="mb-6 flex items-center gap-3">
    <span className="h-7 w-1.5 shrink-0 rounded-full bg-[#FEB13F]" />
    <h3 className="text-xl font-semibold text-[#154A79]">{title}</h3>
    {pill !== undefined && (
      <span className="rounded-full bg-slate-100 px-2.5 py-1 text-xs font-medium text-slate-500">
        {pill}
      </span>
    )}
  </div>
);

const formatSize = (bytes) => {
  if (bytes == null) return "";
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};

/* ------------------------------------------------------------------ */
/*  Component                                                           */
/* ------------------------------------------------------------------ */
const Upload = () => {
  const [inputFiles, setInputFiles] = useState("");
  const fileInputRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [allchecklist, setAllCheckList] = useState([]);
  const [selectedlist, setSelectedList] = useState([]);
  const [encrypted, setencrypted] = useState("");
  const [expandedcategory, setExpandedCategory] = useState(1);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    let getlist = async () => {
      try {
        let result = await checklist();
        if (result) {
          setLoading(false);
          setAllCheckList(result.data.check_list);
          setCategory(result.data.category);
        } else {
          toast.error("Problem fetching data, Please inform Dev team");
        }
      } catch (e) {
        toast.error(e);
      }
    };
    getlist();
  }, []);

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const files = e.dataTransfer.files;
    handleFiles(files);
  };

  const handleFiles = (files) => {
    if (files) {
      const reader = new FileReader();

      reader.readAsDataURL(files[0]);

      reader.onloadend = () => {
        setencrypted(reader.result);
      };

      setInputFiles(files);
      startUploadSimulation();
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleRemoveFile = () => {
    setInputFiles("");
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const startUploadSimulation = () => {
    setIsUploading(true);
    setUploadPercentage(0);

    const interval = setInterval(() => {
      setUploadPercentage((prevPercentage) => {
        if (prevPercentage >= 100) {
          clearInterval(interval);
          setIsUploading(false);
          return 100;
        }
        return prevPercentage + 10;
      });
    }, 100);
  };

  const handlecheck = (id) => {
    if (id === true || id === false) {
      if (id === true) {
        setSelectedList(allchecklist.map((e) => e.id));
        setExpandedCategory("1");
      } else {
        setSelectedList([]);
      }
    } else {
      if (selectedlist.indexOf(id) >= 0) {
        setSelectedList(selectedlist.filter((item) => item !== id));
      } else {
        setSelectedList([...selectedlist, id]);
      }
    }
  };

  const handleSubmit = async () => {
    if (selectedlist.length === 0) {
      toast.info("Please select atleast one option in checklist");
      return;
    } else {
      if (inputFiles) {
        toast.info("uploading file please wait ...", { autoClose: false });
        let result = await upload_files(
          encrypted,
          inputFiles[0].name,
          selectedlist
        );
        if (result.data) {
          toast.dismiss();
          toast.success("File uploaded successfully");
          navigate("/filehistory");
        } else {
          toast.dismiss();
          let error = result.error.message;
          toast.error(error);
        }
      } else {
        toast.info("Please select file to proceed");
      }
    }
  };

  const groupedChecklist =
    allchecklist && allchecklist.length > 0
      ? allchecklist.reduce((groups, item) => {
          if (!groups[item.catagory]) {
            groups[item.catagory] = [];
          }
          groups[item.catagory].push(item);
          return groups;
        }, {})
      : {};

  const toggleCategory = (id) => {
    if (expandedcategory === id) {
      setExpandedCategory("-1");
    } else {
      setExpandedCategory(id);
    }
  };

  const file = inputFiles && inputFiles[0];
  const allSelected =
    selectedlist.length > 0 && selectedlist.length === allchecklist.length;
  const uploadDone = uploadPercentage >= 100 && !isUploading;

  return (
    <LoadingScreen
      loading={loading}
      bgColor="#f8fafc"
      spinnerColor="#154A79"
      textColor="#475569"
      text="Fetching data, please wait…"
    >
      <div className="min-h-full w-full bg-slate-50">
        {/* Top bar */}
        <header className="sticky top-[80px] z-20 flex w-full items-center justify-between gap-4 border-b border-slate-200 bg-white/95 px-6 py-4 backdrop-blur md:px-8">
          <div className="min-w-0">
            <h2 className="truncate text-xl font-bold text-[#154A79] md:text-2xl">
              Upload Article
            </h2>
            <p className="mt-0.5 text-xs text-slate-500 md:text-sm">
              Add a manuscript and choose the checks to run on it
            </p>
          </div>
        </header>

        <main className="px-6 py-8 md:px-10">
          <div className="grid grid-cols-1 items-start gap-6 lg:grid-cols-2">
            {/* ---------------- Manuscript ---------------- */}
            <section className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm md:p-8">
              <SectionTitle title="Manuscript" />

              <div
                className={`flex w-full flex-col items-center justify-center rounded-2xl border border-dashed px-6 py-12 text-center transition-colors ${
                  dragging
                    ? "border-[#FEB13F] bg-[#FEF5E0]"
                    : "border-slate-300 bg-slate-50"
                }`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                <span
                  className={`mb-5 flex h-14 w-14 items-center justify-center rounded-2xl ${
                    dragging
                      ? "bg-white text-[#B7791F]"
                      : "bg-[#154A79]/[0.06] text-[#154A79]"
                  }`}
                >
                  <IconUploadCloud size={26} />
                </span>

                {dragging ? (
                  <p className="text-base font-semibold text-[#154A79]">
                    Drop your file to upload
                  </p>
                ) : (
                  <>
                    <div className="flex flex-wrap items-center justify-center gap-1.5">
                      <p className="text-base font-medium text-slate-600">
                        Drag and drop your file here, or
                      </p>
                      <button
                        type="button"
                        onClick={handleClick}
                        className="text-base font-semibold text-[#154A79] underline underline-offset-2 hover:text-[#1B5E96]"
                      >
                        choose a file
                      </button>
                    </div>
                    <p className="mt-2 text-sm text-slate-400">
                      Word or TeX files (.doc, .docx, .tex)
                    </p>
                  </>
                )}

                <input
                  type="file"
                  name="project_name"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  multiple
                  onChange={(e) => handleFiles(e.target.files)}
                  accept=".doc, .docx, .tex"
                />
              </div>

              {file && (
                <div className="mt-5 rounded-2xl border border-slate-200 bg-white p-4">
                  <div className="flex items-center gap-3">
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#154A79]/[0.06] text-[#154A79]">
                      <IconFileText size={18} />
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-semibold text-slate-700">
                        {file.name}
                      </p>
                      <p className="text-xs text-slate-400">
                        {formatSize(file.size)}
                      </p>
                    </div>
                    {uploadDone && (
                      <span className="inline-flex items-center gap-1.5 rounded-full bg-[#EAF7F1] px-3 py-1 text-xs font-semibold text-[#1B8A5A]">
                        <IconCheckCircle size={13} />
                        Ready
                      </span>
                    )}
                    <button
                      type="button"
                      onClick={handleRemoveFile}
                      aria-label="Remove file"
                      className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-slate-400 transition-colors hover:bg-slate-100 hover:text-[#D64545]"
                    >
                      <IconClose size={16} />
                    </button>
                  </div>

                  <div className="mt-4 flex items-center gap-3">
                    <div className="h-2 flex-1 overflow-hidden rounded-full bg-slate-100">
                      <div
                        className={`h-2 rounded-full transition-all ${
                          uploadDone ? "bg-[#1B8A5A]" : "bg-[#FEB13F]"
                        }`}
                        style={{ width: `${uploadPercentage}%` }}
                      />
                    </div>
                    <p className="w-10 text-right text-xs font-medium tabular-nums text-slate-400">
                      {uploadPercentage}%
                    </p>
                  </div>
                </div>
              )}
            </section>

            {/* ---------------- Checklist ---------------- */}
            <section className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm md:p-8">
              <SectionTitle
                title="Checks to run"
                pill={`${selectedlist.length} of ${allchecklist.length} selected`}
              />

              <label className="mb-3 flex cursor-pointer items-center justify-end gap-2 text-sm font-medium text-slate-600">
                Select all
                <input
                  type="checkbox"
                  className="h-4 w-4 cursor-pointer rounded border-slate-300 accent-[#154A79]"
                  onChange={(e) => handlecheck(e.target.checked)}
                  checked={allSelected}
                />
              </label>

              <div className="max-h-[420px] overflow-y-auto rounded-2xl border border-slate-200">
                {category && allchecklist && allchecklist.length > 0 ? (
                  category.map((value, i) => {
                    const items = groupedChecklist[value.category] || [];
                    const selectedHere = items.filter(
                      (it) => selectedlist.indexOf(it.id) > -1
                    ).length;
                    const isOpen = expandedcategory === value.category;

                    return (
                      <div
                        key={i}
                        className="border-b border-slate-100 last:border-b-0"
                      >
                        <button
                          type="button"
                          onClick={() => toggleCategory(value.category)}
                          aria-expanded={isOpen}
                          className={`flex w-full items-center gap-3 px-4 py-3.5 text-left transition-colors ${
                            isOpen ? "bg-slate-50" : "bg-white hover:bg-slate-50"
                          }`}
                        >
                          <span className="h-5 w-1 shrink-0 rounded-full bg-[#FEB13F]" />
                          <span className="min-w-0 flex-1 truncate text-sm font-semibold text-[#154A79]">
                            {value.value}
                          </span>
                          <span
                            className={`shrink-0 rounded-full px-2.5 py-0.5 text-xs font-medium ${
                              selectedHere > 0
                                ? "bg-[#154A79] text-white"
                                : "bg-slate-100 text-slate-500"
                            }`}
                          >
                            {selectedHere}/{items.length}
                          </span>
                          <IconChevronDown
                            size={18}
                            className={`shrink-0 text-slate-400 transition-transform ${
                              isOpen ? "" : "-rotate-90"
                            }`}
                          />
                        </button>

                        {isOpen && (
                          <ul className="divide-y divide-slate-100 bg-white">
                            {items.map((list, idx) => (
                              <li key={idx}>
                                <label
                                  htmlFor={list.id}
                                  className="flex cursor-pointer items-center gap-3 py-2.5 pl-6 pr-4 transition-colors hover:bg-slate-50"
                                >
                                  <span className="w-6 shrink-0 text-xs tabular-nums text-slate-400">
                                    {idx + 1}
                                  </span>
                                  <span className="min-w-0 flex-1 text-sm text-slate-600">
                                    {list.title}
                                  </span>
                                  <span
                                    title={list.desc}
                                    className="flex shrink-0 text-slate-300 hover:text-[#154A79]"
                                  >
                                    <IconInfo size={16} />
                                  </span>
                                  <input
                                    id={list.id}
                                    type="checkbox"
                                    value={list.title}
                                    className="h-4 w-4 shrink-0 cursor-pointer rounded border-slate-300 accent-[#154A79]"
                                    onChange={() => handlecheck(list.id)}
                                    checked={selectedlist.indexOf(list.id) > -1}
                                  />
                                </label>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div className="flex flex-col items-center justify-center gap-3 px-6 py-14 text-center">
                    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-slate-50 text-slate-300">
                      <IconInbox size={20} />
                    </div>
                    <p className="text-sm font-semibold text-slate-500">
                      No checklist to show
                    </p>
                  </div>
                )}
              </div>
            </section>
          </div>

          {/* ---------------- Action bar ---------------- */}
          <div className="mt-6 flex flex-wrap items-center justify-between gap-4 rounded-3xl border border-slate-200 bg-white px-6 py-4 shadow-sm md:px-8">
            <p className="text-sm text-slate-500">
              {file ? (
                <span className="font-medium text-slate-700">{file.name}</span>
              ) : (
                "No file selected"
              )}
              <span className="mx-2 text-slate-300">|</span>
              {selectedlist.length}{" "}
              {selectedlist.length === 1 ? "check" : "checks"} selected
            </p>
            <button
              type="button"
              onClick={handleSubmit}
              className="rounded-full bg-[#154A79] px-8 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-[#1B5E96] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FEB13F] focus-visible:ring-offset-2"
            >
              Submit
            </button>
          </div>
        </main>
      </div>
    </LoadingScreen>
  );
};

export default Upload;
